import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Typography,
  Grid,
} from '@gogame/components';

import YesNo from './components/YesNo';
import UIDList from './components/UIDList';

export const PlayersInformation = ({ data }) => {
  return (
    <Grid container mt={1}>
      <Grid item container spacing={2}>
        <Grid
          item
          container
          alignItems={'center'}
          xs={12}
          style={{ marginTop: '0' }}
        >
          <Grid item>
            <Typography variant={'subtitle1'} sx={{ fontWeight: 500 }}>
              General info
            </Typography>
          </Grid>
        </Grid>
        <Grid item container>
          <DescriptionList
            termWidth={'160px'}
            data={data}
            disableGutters={true}
            stripEmpty={false}
          >
            <DescriptionItem
              label={'Reg Action ID'}
              field={'regActionId'}
              placeholder={'—'}
            />
            <DescriptionItem
              label={'Advertising ID'}
              field={'advertisingId'}
              placeholder={'—'}
            />
            <DescriptionItem
              label={'UID'}
              field={'umIdInfo'}
              type={({ value }) => <UIDList value={value} />}
            />
            <DescriptionItem
              label={'Player ID'}
              field={'playerId'}
              placeholder={'—'}
            />
            <DescriptionItem
              label={'AppsFlyer ID'}
              field={'appsflyerId'}
              placeholder={'—'}
            />
            <DescriptionItem
              label={'Partner Click ID'}
              field={'partnerClickId'}
              placeholder={'—'}
            />
            <DescriptionItem
              label={'Depositor'}
              field={'isDepositor'}
              type={'status'}
              valueParser={(value) => ({ id: value })}
              statusFactory={YesNo}
            />
            <DescriptionItem
              label={'Gross Deposit Amount'}
              field={'grossDepositAmount'}
              placeholder={'—'}
            />
            <DescriptionItem
              label={'Gross Refund Amount'}
              field={'grossRefundAmount'}
              placeholder={'—'}
            />
            <DescriptionItem
              label={'Last Session'}
              type={'date'}
              field={'lastSessionTime'}
              placeholder={'—'}
              timeZone={'utc'}
            />
          </DescriptionList>
        </Grid>
      </Grid>
    </Grid>
  );
};
